export const DATA_SOURCE_OPTIONS = [
    { key: 'lead_vendor', value: 'Lead Vendor', text: 'Lead Vendor' },
    { key: 'data_broker', value: 'Data Broker', text: 'Data Broker' }
];
